const ExistingCustomerIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1706_5902)">
        <path
          d="M1.28049 24.4787H12.0021C13.645 26.5572 16.1877 27.8933 19.0366 27.8933C23.979 27.8933 28 23.8723 28 18.9299C28 13.9875 23.979 9.96649 19.0366 9.96649C16.0925 9.96649 13.4754 11.3935 11.8404 13.592C11.1777 13.453 10.5007 13.3811 9.81707 13.3811C4.40394 13.3811 0 17.7851 0 23.1982C0 23.9054 0.573317 24.4787 1.28049 24.4787ZM19.0366 12.5275C22.5669 12.5275 25.439 15.3996 25.439 18.9299C25.439 22.4602 22.5669 25.3323 19.0366 25.3323C15.5063 25.3323 12.6341 22.4602 12.6341 18.9299C12.6341 15.3996 15.5063 12.5275 19.0366 12.5275Z"
          fill="#181717"
        />
        <path
          d="M9.81707 0.10672C6.86324 0.10672 4.46028 2.50977 4.46028 5.46351C4.46028 8.41726 6.86324 10.8201 9.81707 10.8201C12.7708 10.8201 15.1738 8.41726 15.1738 5.46351C15.1738 2.50977 12.7708 0.10672 9.81707 0.10672Z"
          fill="#181717"
        />
        <path
          d="M16.4756 20.2104H17.7561V21.4909C17.7561 22.198 18.3294 22.7714 19.0366 22.7714C19.7438 22.7714 20.3171 22.198 20.3171 21.4909V20.2104H21.5976C22.3047 20.2104 22.878 19.6371 22.878 18.9299C22.878 18.2227 22.3047 17.6494 21.5976 17.6494H20.3171V16.3689C20.3171 15.6618 19.7438 15.0884 19.0366 15.0884C18.3294 15.0884 17.7561 15.6618 17.7561 16.3689V17.6494H16.4756C15.7684 17.6494 15.1951 18.2227 15.1951 18.9299C15.1951 19.6371 15.7684 20.2104 16.4756 20.2104Z"
          fill="#181717"
        />
      </g>
      <defs>
        <clipPath id="clip0_1706_5902">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExistingCustomerIcon;
